import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { activateDemoMode } from "../../config/demoMode";
import { clearAuthStorage } from "../../utils/authStorage";

/**
 * Public sales entry: /demo → enable demo session → /login with shortcuts.
 * Clears any production session so the SPA talks only to /demo-api.
 */
function DemoEntry() {
  useEffect(() => {
    clearAuthStorage();
    activateDemoMode();
  }, []);

  return <Navigate to="/login?demo=1" replace />;
}

export default DemoEntry;
